const BASE = ['module'] as const;
const LIST_BASE = [...BASE, 'list'] as const;

export const moduleKeys = {
  all: () => [...BASE] as const,
  publicList: () => [...LIST_BASE] as const,
  get: (moduleID: string | undefined) => [...BASE, { moduleID }] as const,
  list: (organizationID: string) =>
    [...moduleKeys.publicList(), { organizationID }] as const,
  orgVersionSummaries: (organizationID: string | undefined) =>
    [...BASE, 'org-version-summaries', { organizationID }] as const,
  orgRegistryItemUsage: (
    organizationID: string | undefined,
    moduleID: string | undefined
  ) =>
    [...BASE, 'org-registry-item-usage', { organizationID, moduleID }] as const,
};
